
import React from 'react';

const AlbumHeader = (props) => {
   
    return (
        <div className="cover_pic">
            <img className={(props.albumHeader.membership == 'GOLD') ? "user gold_user" : "user"} src={(props.albumHeader.image != '') ? props.albumHeader.image : iconPath['DEFAULTUSER']} 
              onError = {(e) => {
                e.target.src = iconPath['DEFAULTUSER']
              }}
            />
            <h2>{props.albumHeader.full_name}</h2>
            <span>{props.albumHeader.country}</span>


        </div>
    );
} 

export default AlbumHeader;

